export enum FeatureToggle {
  pageBuilderSingleRetailer = 'rt_pagebuilder_single_retailer',
  brandingV2 = 'rt_ipp_branding_v2',
  collectionSelectorAdvanced = 'rt_collection_selector_advanced',
  storefrontProSeoControls = 'rt_storefront_pro_seo_controls',
}
